<template>
  <div class="container">
    <!-- <div class="priceGrad">
      <span class="text24">250$</span>
    </div> -->
    <div class="infoWrapper">
      <InfoButton @click="changePopupState(true)" />
    </div>
    <div class="cardWrapper">
      <p class="text13">
        Логотип на сайті проєкту <br />
        <br />
        Поширення інформації про<br />
        бренд в Instagram stories <br />
        BEST Lviv<br />
        <br />
        Поширення інформації <br />
        про бренд в бесіді <br />
        учасників проєкту<br />
        <br />
        Поширення промоматеріалів <br />
        компанії серед учасників <br />
        проєкту<br />
        <br />
        Фотозвіт<br />
      </p>
    </div>
  </div>
</template>

<script>
import InfoButton from '@/components/InfoButton.vue';

export default {
  name: 'OfferCard',
  components: {
    InfoButton
  },
  methods: {
    changePopupState(payload) {
      document.body.classList.toggle('hiddenOverflow');
      document.querySelector('.blurred').classList.toggle('active');
      this.$store.commit('changePopupState', payload);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  width: 23.333rem;
  padding-left: 2.897rem;
  // padding-top: 2.414rem;
  padding-bottom: 4.414rem;
  position: relative;
  border: solid 2px #4f388d;
}

.cardWrapper {
  padding-top: 2rem;
}

.priceGrad {
  padding: 0.5rem 1rem;
  color: white;
  background: linear-gradient(
    99.09deg,
    #4f388d 0%,
    rgba(79, 56, 141, 0.8) 100%
  );
  box-shadow: 0px 4px 11px rgba(83, 61, 144, 0.51);
  backdrop-filter: blur(5px);
  text-align: center;
  position: absolute;
  right: 2.63em;
  top: -1.18em;
}

.infoWrapper {
  position: absolute;
  right: 0.6em;
  bottom: 0.7em;
  cursor: pointer;
}

@media screen and (max-width: 768px) {
  .container {
    width: 100%;
    height: auto;
  }
  .cardWrapper {
    padding: 7em;
  }
  .priceGrad {
    width: 19.68rem;
    right: 9.06rem;
    top: -4.5rem;
    padding: 1.25rem 0;
  }
  .infoWrapper {
    right: 3.51em;
    bottom: 3.51rem;
    top: auto;
  }
}
</style>
